import api from 'js/api'

export const loginWithEmail = (email, password) =>
  api('POST', 'gatekeeper/v1/login/lifesum', {
    email,
    password,
  })
